/* eslint-disable react/display-name */
import React from 'react'

import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'

import { submitEventForm } from '../../_actions'
import { phonenumber, email } from '../../_helpers'
import {
    Container,
    devices,
    colors,
    Button,
    UpperHeader,
    Input,
    Form,
    FormError,
    MultiChoiceInput,
} from '../Common'

const TextInput = React.forwardRef(({ label, type, name, errors }, ref) => (
    <InputWrap>
        {errors[name] && <FormError>{errors[name].message}</FormError>}
        <Input required color={colors.inputBlack} type={type || 'text'} aria-label={label} placeholder={label} name={name} ref={ref} />
    </InputWrap>
))

const Choice = React.forwardRef(({ id, value }, ref) => (
    <MultiChoiceInput>
        {value}
        <input type='checkbox' name='interest' value={value} id={id} ref={ref} />
        <span />
    </MultiChoiceInput>
))

const EventForm = () => {
    const { register, handleSubmit, errors } = useForm({ mode: 'onBlur' })
    // const { eventMessage, eventError } = useSelector(state => state.form, shallowEqual)
    const dispatch = useDispatch()
    // const onSubmit = data => dispatch(submitEventForm(data))
    const onSubmit = data => console.warn(data)
    const registerOptions = { required: 'This field is required' }

    return (
        <FormContainer>
            <UpperHeader marginbottom={30}>Event Form</UpperHeader>
            <Form onSubmit={handleSubmit(onSubmit)} style={{ width: '50%' }}>
                <TextInput label='Email' type='email' name='email' errors={errors} ref={register({ ...registerOptions, validate: val => email(val) })} />
                <TextInput label='Full Name' name='name' errors={errors} ref={register(registerOptions)} />
                <TextInput label='Company' name='company' errors={errors} ref={register(registerOptions)} />
                <TextInput label='Phone Number' type='tel' name='phone_number' errors={errors} ref={register({ ...registerOptions, validate: val => phonenumber(val) })} />
                <TextInput label='Event Date' name='event_date' errors={errors} ref={register(registerOptions)} />
                <TextInput label='Event Location' name='event_location' errors={errors} ref={register(registerOptions)} />
                <TextInput label='Event Time(s)' name='event_time' errors={errors} ref={register(registerOptions)} />
                <TextInput label='Event Theme' name='event_theme' errors={errors} ref={register(registerOptions)} />
                <TextInput label='Number of Guests' name='number_of_guests' errors={errors} ref={register(registerOptions)} />
                <TextInput label='Budget' name='budget' errors={errors} ref={register(registerOptions)} />
                <InputWrap>
                    <h2>Type of Event</h2>
                    <label>
                        <input type='radio' name='event_type' value='Corporate' ref={register(registerOptions)} />
                        &nbsp; Corporate
                    </label>
                    <label>
                        <input type='radio' name='event_type' value='Gala' ref={register(registerOptions)} />
                        &nbsp; Gala
                    </label>
                    <label>
                        <input type='radio' name='event_type' value='Bar Mitzvah' ref={register(registerOptions)} />
                        &nbsp; Bar Mitzvah
                    </label>
                    <label>
                        <input type='radio' name='event_type' value='Personal Event' ref={register(registerOptions)} />
                        &nbsp; Personal Event
                    </label>
                    <label>
                        <input type='radio' name='event_type' value='School Related' ref={register(registerOptions)} />
                        &nbsp; School Related
                    </label>
                    <label>
                        <input type='radio' name='event_type' value='Other (see below)' ref={register(registerOptions)} />
                        &nbsp; Other: &nbsp;
                        <input type='text' placeholder='Specify' name='other_event' aria-label='specify' ref={register} />
                    </label>
                </InputWrap>
                <InputWrap>
                    <h2>Interest</h2>
                    <p>Check all that apply</p>
                    <Choice id='decor' value='Decor' ref={register} />
                    <Choice id='linens' value='Linens' ref={register} />
                    <Choice id='centerpieces' value='Centerpieces / Florals' ref={register} />
                </InputWrap>
                <Button type='submit' onClick={handleSubmit(onSubmit)}>SUBMIT</Button>
            </Form>
        </FormContainer>
    )
}

const FormContainer = styled(Container)`
    background: ${colors.black};
    padding: 50px;
`

export const InputWrap = styled.div`
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: ${colors.white};
`

export default EventForm